import { Params } from '@angular/router';
import { createSelector } from '@ngrx/store';
import { AppState } from 'src/store/appstate';
import { selectAllCompanies } from 'src/store/entityStores/entity-store-selectors';

export function selectRouteParams() {
  return (state: AppState): Params => state.router?.state.params;
}

export function selectQueryParams() {
  return (state: AppState): Params => state.router?.state.queryParams;
}

export function selectRouteParam(paramName: string) {
  return (state: AppState): string | undefined => state.router?.state.params[paramName];
}

export function selectQueryParam(queryParamName: string) {
  return (state: AppState): string | undefined => state.router?.state.queryParams[queryParamName];
}

export function selectCurrentCompanyFromRoute() {
  return createSelector(
    selectRouteParam('companyCode'),
    selectAllCompanies,
    (companyCode, companies) => {
      return companyCode != null
        ? companies.find((c) => c.companyCode.toLowerCase() === companyCode.toLowerCase())
        : undefined;
    },
  );
}
